export function fiFormatTwoDigit(val: number): string {
    return val > 9 ? `${val}` : `0${val}`;
}
